import { useState } from "react";
import { PageHeader, Tabs } from "../components/common";
import { ManagerJobsList } from "../components/jobs/ManagerJobsList";
import { ManagerRecurringSchedulesList } from "../components/jobs/ManagerRecurringSchedulesList";
import { SPACING } from "../constants/theme";
import { useAuth } from "../hooks/useAuth";

type JobSubTab = "oneTime" | "recurring";

export function ManagerJobs() {
  const { currentUser } = useAuth();
  const [jobSubTab, setJobSubTab] = useState<JobSubTab>("oneTime");

  if (!currentUser) return null;

  return (
    <div style={{ padding: SPACING["2xl"] }}>
      <PageHeader title="Jobs" subtitle="One-time jobs and recurring schedules assigned to your team" />

      <Tabs
        tabs={[
          { value: "oneTime", label: "One-time Jobs" },
          { value: "recurring", label: "Recurring Schedules" },
        ]}
        active={jobSubTab}
        onChange={setJobSubTab}
        variant="pill"
      />

      {jobSubTab === "oneTime" && (
        <ManagerJobsList managerId={currentUser.uid} managerProfile={currentUser} companyTimezone={currentUser.companyTimezone} />
      )}
      {jobSubTab === "recurring" && (
        <ManagerRecurringSchedulesList managerId={currentUser.uid} managerProfile={currentUser} companyTimezone={currentUser.companyTimezone} />
      )}
    </div>
  );
}
